import React, { useState } from 'react';
import { Box, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import SmsAplicationChargeHistory from '../smsAplicationChargeHistory/SmsAplicationChargeHistory';
import SmsChargeHistory from '../smsChargeHistory/SmsChargeHistory';
import SmsSendHistory from '../smsSendHistory/SmsSendHistory';
import SmsUsageHistory from '../smsUsageHistory/SmsUsageHistory';
import SmsTemplateManagement from '../smsTemplateManagement/SmsTemplateManagement';
import SmsSenderNumber from '../smsSenderNumber/SmsSenderNumber';
import SmsSenderRegister from '../smsSenderRegister/SmsSenderRegister';
import SmsBalanceAdjust from '../smsBalanceAdjust/SmsBalanceAdjust';
import { PageContainer, TabContainer, TabButton } from './SmsMainStyled';

// 총관리자: 지점들이 신청한 발신번호를 '승인'
const SUPER_ADMIN_TABS = [
  { id: 'chargeHistory', label: '충전 신청내역' },
  { id: 'senderApprove', label: '발신번호 승인' },
  { id: 'balanceAdjust', label: '포인트 지급/회수' },
];

// 지점: 자기 지점 발신번호를 '등록(신청)' (총관리자 승인 후 사용 가능)
const DEFAULT_TABS = [
  { id: 'sendHistory', label: '발송 내역' },
  { id: 'smsSend', label: '충전 내역' },
  { id: 'smsHistory', label: '템플릿 관리' },
  { id: 'senderRegister', label: '발신번호 등록' },
  { id: 'usageHistory', label: '이용 내역' },
];

const SmsMain = () => {
  const { t } = useTranslation();
  const { user } = useSelector(state => state.user);
  const isSuperAdmin = user?.userRole === 'ROLE_SUPERADMIN';
  const tabs = isSuperAdmin ? SUPER_ADMIN_TABS : DEFAULT_TABS;

  const [activeTab, setActiveTab] = useState(tabs[0].id);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'chargeHistory':
        return <SmsAplicationChargeHistory />;
      case 'senderApprove':
        return <SmsSenderNumber />;
      case 'balanceAdjust':
        return <SmsBalanceAdjust />;
      case 'sendHistory':
        return <SmsSendHistory />;
      case 'smsSend':
        return <SmsChargeHistory />;

      case 'smsHistory':
        return <SmsTemplateManagement />;
      case 'senderRegister':
        return <SmsSenderRegister />;
      case 'usageHistory':
        return <SmsUsageHistory />;
      default:
        return null;
    }
  };

  return (
    <Box component={Paper} elevation={0} style={{ borderRadius: '10px', width: '100%' }}>
      <PageContainer>
        <TabContainer>
          {tabs.map(tab => (
            <TabButton key={tab.id} isActive={activeTab === tab.id} onClick={() => setActiveTab(tab.id)}>
              {t(tab.label)}
            </TabButton>
          ))}
        </TabContainer>

        {renderTabContent()}
      </PageContainer>
    </Box>
  );
};

export default SmsMain;
